// extracted by mini-css-extract-plugin
export default {"RainbowButton":"NextButton_RainbowButton__yBq1i","InputButton":"NextButton_InputButton__yXaq2","slidebg":"NextButton_slidebg__HY+ql"};